// For the dashboard cards and map
// Monitors the flight channel and updates cards and the map

import { Controller } from "@hotwired/stimulus"
import consumer from '../channels/consumer';

export default class extends Controller {

  connect() {
    this.channel = consumer.subscriptions.create('FlightChannel', {
      connected: this._cableConnected.bind(this),
      disconnected: this._cableDisconnected.bind(this),
      received: this._cableReceived.bind(this),
    });
  }

  disconnect() {
    if (this.channel) this.channel.unsubscribe();
  }

  // Broadcasts sent while this browser was disconnected are lost, so re-sync
  // from the database on every (re)connect rather than trusting the cards.
  _cableConnected({ reconnected } = {}) {
    console.log(`APcable dashboard ${reconnected ? 'reconnected' : 'connected'}, re-syncing activation state`);
    this.syncActivationStatus(reconnected);
  }

  _cableDisconnected() {
    // Called when the subscription has been terminated by the server
  }

  syncActivationStatus(reconnected = false) {
    const ids = Array.from(document.querySelectorAll('[id^="card-"]'))
                     .map(card => card.id.replace('card-', ''));
    if (ids.length === 0) return;

    fetch(`/airport/dashboard/activation-status?ids=${ids.join(',')}`, {
      headers: { 'Accept': 'application/json' }
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      let changed = 0;
      for (let assessmentId in data) {
        // One bad card must not stop the rest being corrected
        try {
          if (this.updateCard(assessmentId, data[assessmentId]['activated'])) changed++;
        } catch (error) {
          console.error(`APcable failed to update card ${assessmentId}:`, error);
          window.airbrake?.notify({ error: error, context: { component: 'APcable dashboard card update', assessmentId: assessmentId } });
        }
      }
      console.log(`APcable dashboard ${reconnected ? 're-sync after reconnect' : 'initial sync'}: ` +
                  `${Object.keys(data).length} cards checked, ${changed} corrected`);
    })
    .catch(error => {
      if (error.name === 'AbortError') return;
      console.error('APcable failed to fetch dashboard activation status:', error);
      window.airbrake?.notify({ error: error, context: { component: 'APcable dashboard activation sync' } });
    });
  }

  _cableReceived(data) {
    console.log(`APcable broadcast received: assessment ${data.assessment} activated=${data.activated}`);
    this.updateCard(data.assessment, data.activated);
  }

  // Returns true if the card's activation state actually changed.
  updateCard(assessmentId, activated) {
    let card = document.getElementById(`card-${assessmentId}`);
    if (!card) return false;
    if (card.dataset.activated === String(activated)) return false;

    if (activated) {
      card.dataset.activated = 'true'
      card.classList.add('card-flight-activated')
      this.mapController?.activateShape(assessmentId)
    } else {
      card.dataset.activated = 'false'
      card.classList.remove('card-flight-activated')
      this.mapController?.deactivateShape(assessmentId)
    }
    return true;
  }

  get mapController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("dashboard-map-id"), "dashboard-map")
  }

}
